var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4279 6.07144H9.64216C9.16856 6.07144 8.71436 6.25958 8.37947 6.59447C8.04458 6.92935 7.85645 7.38356 7.85645 7.85716V22.1429C7.85645 22.6165 8.04458 23.0707 8.37947 23.4056C8.71436 23.7404 9.16856 23.9286 9.64216 23.9286H11.4279C11.9015 23.9286 12.3557 23.7404 12.6906 23.4056C13.0255 23.0707 13.2136 22.6165 13.2136 22.1429V7.85716C13.2136 7.38356 13.0255 6.92935 12.6906 6.59447C12.3557 6.25958 11.9015 6.07144 11.4279 6.07144Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3566 6.07144H18.5709C18.0973 6.07144 17.6431 6.25958 17.3082 6.59447C16.9733 6.92935 16.7852 7.38356 16.7852 7.85716V22.1429C16.7852 22.6165 16.9733 23.0707 17.3082 23.4056C17.6431 23.7404 18.0973 23.9286 18.5709 23.9286H20.3566C20.8302 23.9286 21.2844 23.7404 21.6193 23.4056C21.9542 23.0707 22.1423 22.6165 22.1423 22.1429V7.85716C22.1423 7.38356 21.9542 6.92935 21.6193 6.59447C21.2844 6.25958 20.8302 6.07144 20.3566 6.07144Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.72d916ea314b5b8debdb914043da7ed4.svg";
export { ForwardRef as ReactComponent };